// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"380":"21b53092","469":"21b53092","490":"1fa444a1","558":"3c9d8d9b","971":"7b3aec7d"}[chunkId] + ".chunk.css";
};